import type { Dispatch, FC, SetStateAction } from 'react';
import React, { useCallback } from 'react';
import OptionStepper from './OptionsStepper';
import type { CartAdditionOption } from '../../../../../types/cart';
import { isEqualNotOptionId, isEqualOptionId } from '../../../../utils/cart';
import type { OptionDto, OptionGroupDto } from '../../../../../generated-api';
import { useCheckout } from '../../../../context/CheckoutContext';

interface Props {
  optionGroup: OptionGroupDto;
  setOptions: Dispatch<SetStateAction<CartAdditionOption[]>>;
  defaultOptions: CartAdditionOption[];
}

const QuantitySelection: FC<Props> = ({ optionGroup, setOptions, defaultOptions }) => {
  const { vatType } = useCheckout();
  const handleSelection = useCallback(
    (option: OptionDto, quantity: number) => {
      if (quantity === 0) {
        setOptions((cartOptions) => cartOptions.filter(isEqualNotOptionId(option)));
      } else {
        setOptions((cartOptions) => {
          const index = cartOptions.findIndex(isEqualOptionId(option));
          return index === -1
            ? cartOptions.concat({ option, quantity, type: optionGroup.productType, vatType })
            : [
                ...cartOptions.slice(0, index),
                { option, quantity, type: optionGroup.productType, vatType },
                ...cartOptions.slice(index + 1),
              ];
        });
      }
    },
    [setOptions, optionGroup.productType, vatType]
  );

  return (
    <div className="divide-y divide-grey-medium">
      {optionGroup.options.map((option) => (
        <OptionStepper
          key={option.optionId}
          option={option}
          onSelection={handleSelection}
          defaultOptions={defaultOptions}
        />
      ))}
    </div>
  );
};

export default QuantitySelection;
